<style>
    .rich-text-editor-container{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(55,55,55,.6);
        text-align: center;
        z-index: 999;
    }
    .rich-text-editor-wrapper{
        position: relative;
        margin-top: 100px;
        display: inline-block;
        background: white;
    }
    .rich-text-editor-close{
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .rich-text-editor {
        /*max-height: 400px;*/
        /*overflow: auto;*/
    }
    .ql-toolbar.ql-snow{
        padding: 8px 80px 8px 8px !important;
    }
</style>


<template>
    <div class="rich-text-editor-container" v-show="config.show">
        <div class="rich-text-editor-wrapper">
            <div class="rich-text-editor-close btn btn-xs btn-default" @click.prevent.stop="dismiss()">结束编辑</div>
            <div class="rich-text-editor"></div>
        </div>
    </div>
</template>



<script type="text/ecmascript-6">
//    import ImageResize from 'quill-image-resize-module'
export default {
    props: {
        config: {
            type: Object
        },
        text: {
            type: String,
            validator: function (value) {
                if (value === undefined) {
                    console.error('必须有text字段!');
                }
                return value != undefined;
            }
        }
    },
    computed: {

    },
    watch: {
        text: function (newValue) {
            if (this.quill) {
                this.quill.root.innerHTML = newValue;
            }
        }
    },
    data () {
        return {
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function () {
//            Quill.register('modules/imageResize', ImageResize)
            let toolbarOptions = this.config.options;
            if (!toolbarOptions) {
                toolbarOptions = [
                    [{ 'color': [] }, { 'background': [] }, { 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'align': [] }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],

                    ['link', 'image'],
                    //[{ 'direction': 'rtl' }],


                    //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    // [{ 'font': [] }],

                    ['clean']
                ];
            }
            let imageHandler = function(image, callback) {
                console.log(image);
                let formData = new FormData();
                formData.append('image', image, image.name);

                let xhr = new XMLHttpRequest();
                xhr.open('POST', 'handler.php', true);
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        callback(xhr.responseText);
                    }
                };
                xhr.send(formData);
            };

            this.quill = new Quill(this.$el.querySelector('.rich-text-editor'), {
                modules: {
                    toolbar: toolbarOptions,
//                    imageResize: {
//                        // See optional "config" below
//                    }
                },
                placeholder: 'Input some text...',
                theme: 'snow',
            });
//            this.quill.getModule("toolbar").addHandler("image", imageHandler);

            this.quill.root.innerHTML = this.text;
        },
        dismiss: function () {
            console.log(this.quill.root.innerHTML);
            this.$emit('textchange', this.quill.root.innerHTML, this.config.key);
            this.$emit('update:text', this.quill.root.innerHTML);       // 支持sync双向绑定
            this.config.show = false;
        }
    }
}



</script>